import React from "react";

import ArticleCard from "../../components/cards/articleCard";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import ArrowRightIcon from "../../images/icons/arrow-right-icon.inline.svg";
import DragonFlyIllustration from "../../images/illustrations/Dragonfly.inline.svg";
import { Link } from "../../utils/customLink";
import { ConditionalSwiper } from "../shared/conditionalSwiper";

const TextArticles = ({ articleList, viewMoreLink, viewMoreLabel }) => {
  const breakpoint = useBreakpoint();

  if (articleList && articleList?.length < 1) {
    return <></>;
  }

  return (
    <>
      {articleList && articleList?.length > 0 && (
        <section className="relative flex items-center justify-center px-4 md:px-0 bg-generic-bg dark:gvi-light-gray-bg overflow-hidden">
          <DragonFlyIllustration className="absolute hidden dark:block -left-[54%] md:-left-[15%] -bottom-[73%] md:-bottom-[65%]" />

          <div className="relative container z-10 w-full md:w-4/5 py-16 md:pt-20 md:pb-36">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
              <ConditionalSwiper
                condition={breakpoint === "xs"}
                slidesPerView={1.25}
                spaceBetween={10}
                centeredSlides={false}
                className="w-full h-full"
              >
                {articleList &&
                  articleList?.length > 0 &&
                  articleList?.map((article, idx) => (
                    <div
                      className="relative flex flex-col rounded-md h-full sm:gvi-program-card-box"
                      key={idx}
                    >
                      {article?.title && (
                        <ArticleCard
                          article={article}
                          type="text"
                          wholeSelectable={true}
                          extraContentClass="sm:h-full"
                        />
                      )}
                    </div>
                  ))}
              </ConditionalSwiper>
            </div>

            {viewMoreLink && (
              <div className="flex items-center justify-start pt-5 md:hidden">
                <div>
                  <Link
                    className="flex flex-row items-center justify-center link-white-underline !text-generic-text dark:!text-white"
                    to={viewMoreLink}
                  >
                    {viewMoreLabel}
                    <ArrowRightIcon className="ml-4 stroke-black-lighter dark:stroke-white" />
                  </Link>
                </div>
              </div>
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default TextArticles;
